var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{attrs:{"type":"bar","height":"500","options":_vm.chartOptions,"series":_vm.chartSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }